import React, { useEffect, useState } from 'react'
import { starSign2images, StarSignImagesPath } from '../../utils/mapper'
import { STAR_SIGN } from '../../types/enums'

interface StarSignProps {
  starSignName: STAR_SIGN
  parentHandleClick: () => void
  isClicked: boolean
}

/** Componente utilizzato per mostrare un segno zodiacale (con immagine - che differisce se si è in hover) e permetterne il click
 *
 * @param starSignName il nome del segno zodiacale
 * @param parentHandleClick funzione che sarà triggerata al click sul componente corrente
 * @param isClicked se true, il componente corrente è stato cliccato
 *
 */
const StarSign = ({ starSignName, parentHandleClick, isClicked }: StarSignProps) => {
  const [isHover, setHover] = useState(false)
  const [isHighlight, setHighlight] = useState(false)

  const imagesPaths: StarSignImagesPath = starSign2images[starSignName] ?? {
    imagePath: '',
    hoverImagePath: ''
  }

  const handleClick = (e: any) => {
    e.preventDefault()
    parentHandleClick()
  }

  useEffect(() => {
    if (isClicked) {
      setHighlight(true)
    } else {
      setHighlight(false)
    }
  }, [isClicked])

  return (
    <div
      id={starSignName + '-img-container'}
      className={'hover:cursor-pointer w-full flex justify-center'}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={(e) => handleClick(e)}>
      <img
        id={starSignName + '-img'}
        src={`${isHover || isHighlight ? imagesPaths.hoverImagePath : imagesPaths.imagePath}`}
        alt={`Logo ${starSignName}`}
      />
    </div>
  )
}

export default StarSign
